<template>
  <div class="laboratory ma-0 mb-5">
    <div v-if="$i18n.locale=='tc'" class='my-2 subtitle-1 font-weight-medium'> {{ api.experiment_set_full_chi }}</div>
    <div v-else class='my-2 subtitle-1 font-weight-medium'> {{ api.experiment_set_full }}</div>
    <v-alert v-if="equipmentLock==true" border="left" color="red lighten-1" dark>
      <div v-if="$cookies.get('role')=='player'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_experiment_user") }}
      </div>
      <div v-else-if="$cookies.get('role')=='overrider'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_experiment_overrider") }}
      </div>
    </v-alert>
    <v-alert v-else-if="bookingLock==true" border="left" color="red lighten-1" dark>
      <div v-if="$cookies.get('role')=='player'">        
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_booking_user") }}
      </div>
      <div v-else-if="$cookies.get('role')=='overrider'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_booking_overrider") }}
      </div>
    </v-alert>
    <v-alert v-else-if="bookingLock==false && equipmentLock==false && $cookies.get('role')=='overrider'" border="left" color="red lighten-1" dark>
      <div>
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_enter_overrider") }}
      </div>
    </v-alert>
      <div v-if="loaded">
        <div v-if="name == 'environmental_monitoring'">
          <EnvironmentalMonitoring @changeCheck="changeCheckGroupSlotEnd" @changeOverride="changeOverride" />
        </div>
        <div v-if="name == 'photosynthesis'">
          <Photosynthesis @changeCheck="changeCheckGroupSlotEnd" @changeOverride="changeOverride" />
        </div>
        <div v-if="name == 'respiration'">
          <Respiration @changeCheck="changeCheckGroupSlotEnd" @changeOverride="changeOverride" />
        </div>
      </div>
    <v-overlay absolute :value="initialize">
      <v-progress-circular
        :size="50"
        :width="5"
        color="green accent-2"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import ExperimentBasic from "@/services/iot/api_basic_experiment";
import EnvironmentalMonitoring from "@/components/experiment/EnvironmentalMonitoring.vue";
import Photosynthesis from "@/components/experiment/Photosynthesis.vue";
import Respiration from "@/components/experiment/Respiration.vue";

import {api_booking} from '@/services/iot/api_booking';
const apiBookingService = new api_booking(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
    EnvironmentalMonitoring,
    Photosynthesis,
    Respiration,
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      name: "",
      override: 0,
      equipmentLock: false,
      bookingLock:false,
      bookingOverride: false,
      checkEnd: true,
      inte: null,
      role: null,
      drawer: true,
      initialize: true,
      loaded: false,
      mini: true,
      school_id: "",
      api:{
        school: null,
        school_name: null,
        school_chi_name: null,
        experiment: null,
        equipment_id: null,
        school_logo: null,
        experiment_name: null,
        experiment_set_full: null,
        experiment_set_full_chi: null,
      },
    };
  },
  mounted: function () {
    var self = this;
    self.name = self.$route.params.experiment;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.params.experiment;
    self.equipment_id = self.$route.params.equipment_id;
    self.$store.state.current.school_id = self.school_id;
    self.$store.state.current.experiment = self.experiment;
    self.$store.state.current.equipment_id = self.equipment_id;
    
    console.log(self.$store.state.user.username);
    setTimeout(function(){
      if(self.$route.name == 'experiment'){
      }
      else {
        clearInterval(self.kick_inte);
      }
      self.initialization();
    },1000);
  },
  methods: {
    updateKickTime(time) {
      this.$emit("kickTime", (parseInt(time)*1000 - new Date().getTime())/1000);
    },
    initialization(){
      var self = this;
      apiBookingService.getSchool(self.school_id)
        .then((response) => {
          if(response.status=='success') {
            self.api.school = response.school;
            self.api.school_name = response.school_name;
            self.api.school_chi_name = response.school_chi_name;
            apiBookingService.getSchoolExperimentSet(self.school_id, self.experiment, self.equipment_id)
              .then((response) => {
                if(response.status=='success') {
                  self.api.experiment = self.experiment;
                  self.api.equipment_id = self.equipment_id;
                  apiBookingService.getEquipmentAndGroupExperimentStatus(self.$cookies.get("group_slot_id"),self.school_id, self.experiment, self.equipment_id)
                    .then((response) => {
                      if(response.eStatus=="HOLD"){
                        self.equipmentLock = true;
                      }
                      if(response.bStatus=="SUSPENDED" || response.bStatus=="UNAVAILABLE" || response.bStatus=="MAINTENANCE"){
                        self.bookingLock = true;
                      }
                      
                      self.loaded = true;
                      
                      self.initialize = false;
                      
                      self.api.experiment_set_full = response.experiment_set_full;
                      self.api.experiment_set_full_chi = response.experiment_set_full_chi;
                      
                      
                      if(self.equipmentLock == true && self.$cookies.get("role")=="overrider") {
                        //self.checkBookingEnd();
                      }
                      else self.changeCheckGroupSlotEnd();
                      self.inte = setInterval(function() {
                        if( self.equipmentLock == true && self.$cookies.get("role")=="overrider" ) {
                          // no action
                        }
                        else {
                          self.changeCheckGroupSlotEnd();
                        }
                      }, 10000);      
                        
                    });
                }
                else {
                  self.initialize = false;
                  alert(response.error);
                }
              });
          }
          else {
            self.initialize = false;
            alert(response.error);
          }
        });
    },
    changeCheckGroupSlotEnd(){
      var self = this;
      self.checkEnd = !self.checkEnd;
    },
    changeOverride(override){
      var self = this;
      if (override.bStatus == "SUSPENDED")
        self.bookingLock = true;
      else 
        self.bookingLock = false;
      if (override.eStatus == "HOLD")
        self.equipmentLock = true;
      else 
        self.equipmentLock = false;
    },    
  },
  destroyed(){
    var self = this;
    clearInterval(self.inte);
    self.$cookies.remove("experiment");
    self.$cookies.remove("equipment_id");
    self.$cookies.remove("end_at");
    self.$cookies.remove("booking_id");
    self.$cookies.remove("session_token");
    self.$store.state.current.booking_id = null;
    self.$store.state.current.end_at = null;
    self.$store.state.current.school_id = null;
    self.$store.state.current.experiment = null;
    self.$store.state.current.equipment_id = null;
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>